import { Controller } from "@hotwired/stimulus"

// Copies the source target's text to the clipboard, flashing a transient label
// on the button. Used for API keys and any other copy-to-clipboard control.
export default class extends Controller {
  static targets = ["source", "button"]

  copy() {
    const text = this.sourceTarget.value ?? this.sourceTarget.textContent
    navigator.clipboard.writeText(text.trim()).then(() => {
      if (!this.hasButtonTarget) return
      const original = this.buttonTarget.textContent
      this.buttonTarget.textContent = "Copied!"
      setTimeout(() => { this.buttonTarget.textContent = original }, 2000)
    })
  }
}
